import { commonUrl, getRequest, ResponseDI } from "../../../base/services/urlService";
import { ListsFil } from "../types";

export const getLists = async () => {
    const url = `${commonUrl}/api/lesson/GetLists`
    const results = await getRequest<ResponseDI<ListsFil>>(url); //other type
    return results.result;
}
